module.exports = __webpack_public_path__ + "ebf0252c40c121aadb97ae632970c7f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/games/coh_image_mobile.jpg
// module id = 503
// module chunks = 0